import { ParameterContainerDefault } from "./default-parameter-container.component";
import { ParameterMultiContainerDefault } from "./default-multiparameter-container.component";
import { ParameterGroupContainerDefault } from "./default-parameter-group-container.component";
export const defaultInputParameterComponents = {
  ParameterContainer: ParameterContainerDefault,
  ParameterGroupContainer: ParameterGroupContainerDefault,
  ParameterMultiContainer: ParameterMultiContainerDefault
};
export const defaultInputMultiParameterComponents = {
  ParameterContainer: ParameterContainerDefault
};